/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Sidebar_Buttons_DescriptionInputs */

const es_walkthrough_sidebar_buttons_description = /** @type {(inputs: Walkthrough_Sidebar_Buttons_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiá entre tema claro y oscuro, accedé a Configuración o enviá feedback — todo desde acá.`)
};

const en_walkthrough_sidebar_buttons_description = /** @type {(inputs: Walkthrough_Sidebar_Buttons_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch between dark and light theme, access Settings, or send feedback — all from here.`)
};

/**
* | output |
* | --- |
* | "Switch between dark and light theme, access Settings, or send feedback — all from here." |
*
* @param {Walkthrough_Sidebar_Buttons_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_sidebar_buttons_description = /** @type {((inputs?: Walkthrough_Sidebar_Buttons_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Sidebar_Buttons_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_sidebar_buttons_description(inputs)
	return en_walkthrough_sidebar_buttons_description(inputs)
});
export { walkthrough_sidebar_buttons_description as "walkthrough.sidebar_buttons_description" }